import { render, staticRenderFns } from "./TagFilter.ts.vue?vue&type=template&id=bff503ae"
import script from "./TagFilter.ts.vue?vue&type=script&lang=ts"
export * from "./TagFilter.ts.vue?vue&type=script&lang=ts"
import style0 from "./TagFilter.ts.vue?vue&type=style&index=0&id=bff503ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports